var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cd-section",attrs:{"id":"testimonials"}},[_c('Testimonial1'),_c('Testimonial2'),_c('Testimonial3')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }